// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".confirmation__buttom[data-v-9a245b38]{display:flex;justify-content:center;align-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
